import { useState } from 'react'
import { DIWellnessCarousel, HubspotBrochureDownload } from '.'
// import { Collapse, UncontrolledCollapse, Button, CardBody, Card } from 'reactstrap'

const DIWellnessGuide = (props) => {
  return (
    <>
      <section className="contentmainN ptb0 pt-5">
        <div className="container customCampaignContainer">
          <div className="row d-flex align-items-center">
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 ">
              <div className="subTextHeading text-left">You will get to learn:</div>
              <div>
                <ul className="mainbullets mt-4">
                  <li>Understand Diversity and Inclusion</li>
                  <li>Cultivate an inclusive and diverse work community with Vantage Fit</li>
                  <li>Learn how to build empathy and allyship with D&I wellness guides</li>
                  <li>Improve business outcomes and employee innovation by incorporating D&I wellness programs</li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 text-center" id="implementationCarousel">
              <DIWellnessCarousel />
            </div>
          </div>
        </div>
      </section>
      <div id="downloadForm"></div>
      <section className="sectionSpacing">
        <div className="container customCampaignContainer">
          <div className="row">
            <div
              className="col-md-6 col-md-offset-2  col-sm-offset-2 col-xs-12 col-sm-12 col-lg-6 col-lg-offset-2 text-center shadow"
              style={{ margin: 'auto', borderRadius: '16px', padding: '60px 30px' }}
            >
              <div className="mainHeadingN ">Download Now</div>
              <div className="innerSpace guide-form">
                <HubspotBrochureDownload formID="298d6342-5e4e-4d33-8241-5cb75cc43075" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default DIWellnessGuide
